import * as _ from "lodash";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { AccordionSingleItem } from "./AccordionSingleItem";

// Accordion with a single item opened at a time
export function AccordionSingle({ items }) {
	const firstKey = _.camelCase(items[0]?.props.item.title);
	const [activeKey, setActiveKey] = useState(firstKey);

	if (items.length === 0) {
		return null;
	}

	const accordionItems = items.map((item) => {
		const title = item.props.item.title;
		const key = _.camelCase(title);
		return (
			<AccordionSingleItem
				key={key}
				id={key}
				title={title}
				isActive={key === activeKey}
				onShow={() => setActiveKey(key)}
			>
				{item}
			</AccordionSingleItem>
		);
	});

	return <div className="accordion">{accordionItems}</div>;
}

AccordionSingle.propTypes = {
	items: PropTypes.arrayOf(PropTypes.element).isRequired,
};
